import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';

const DeleteSubscriptionDialog = ({
  open,
  onClose,
  handleDeleteSubscription,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to delete this subscription? You will no longer
          be able to view or manage it.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          Cancel
        </Button>
        <Button
          onClick={handleDeleteSubscription}
          startIcon={<DeleteRoundedIcon />}
          variant="contained"
          color="error"
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSubscriptionDialog;
